// @flow

import React from 'react'

import upIcon from '../../Icons/icon-up.svg'
import downIcon from '../../Icons/icon-down.svg'
import neutralIcon from '../../Icons/icon-neutral.svg'
import InfoIcon from '../../Icons/icon-info-grey.svg'

import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'
import styled from 'styled-components'

const HeaderTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94919F;
`

type Props = {
  value: number,
  delta: number,
  sinceText: string,
  title: string,
  usePercent: boolean,
  showTooltip: boolean
}

function InfoBlock ({ value, delta, sinceText, title, usePercent, showTooltip }: Props) {
  const deltaPct = delta ? `${(delta).toFixed(0)}%` : '0'
  const convertedDelta = delta ? delta.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : null
  const convertedSinceText = sinceText ? sinceText.charAt(0).toUpperCase() : null

  const conversion = usePercent ? deltaPct : convertedDelta

  return (
    <div className='BlockItem' style={{ minHeight: '147px' }}>
      <div className='flex align-center'>
        <HeaderTitle>{title}</HeaderTitle>
        {showTooltip && (
          <div className='tooltip'>
            <span><img className='icon-md' src={InfoIcon} alt={InfoIcon} /></span>
            <span
              className='tooltipText'>Calculation for duration is the average of all user sessions platform wide.</span>
          </div>
        )}
      </div>
      <Row>
        <Column classNames={['is-8 is-8-desktop']}>
          <h1>{value}</h1>
        </Column>
        <Column classNames={['is-4 is-4-desktop']}>
          <span> {convertedSinceText + sinceText.slice(1)} </span>
          {delta === null || typeof (delta) === 'undefined'
            ? <div><h3 className='flex align-center' style={{ fontWeight: 'normal', gap: '5px' }}><img src={neutralIcon} alt='Neutral' /> ---</h3></div>
            : delta === 0
              ? <div><h3 className='flex align-center' style={{ fontWeight: 'normal', gap: '5px' }}><img src={neutralIcon} alt='Neutral' /> 0</h3></div>
              : delta > 0
                ? <div><h3 className='flex align-center' style={{ fontWeight: 'normal', gap: '5px' }}><img src={upIcon} alt='Up' /> {conversion}</h3></div>
                : <div><h3 className='flex align-center' style={{ fontWeight: 'normal', gap: '5px' }}><img src={downIcon} alt='Down' /> {conversion}</h3></div>}
        </Column>
      </Row>
    </div>
  )
}

export default InfoBlock
